import Cookies from 'js-cookie';
import { getNeedMobile } from '@/api/login'
const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
    needMobile: sessionStorage.getItem("needMobile")
  },

  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1);
      } else {
        Cookies.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    },
    SET_NEED_MOBILE: (state, needMobile) => {
      state.needMobile = needMobile;
    }
  },

  actions: {
    ToggleSideBar: ({commit}) => {
      commit('TOGGLE_SIDEBAR');
    },
    SetNeedMobile: ({commit, state}) => {
      return state.needMobile != null && state.needMobile != undefined?
        Promise.resolve(JSON.parse(state.needMobile)) :
        new Promise((resolve, reject) => {
        getNeedMobile().then(response => {
          sessionStorage.setItem('needMobile',response.data.needMobile);
          commit('SET_NEED_MOBILE', response.data.needMobile);
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    }
  }
};

export default app;




// WEBPACK FOOTER //
// ./src/store/modules/app.js